<template>
  <div id="nav">
    <img src="../assets/logo.png" />
    <router-link to="/admins">Admins</router-link>
    <router-link to="/appointments">Appointments</router-link>
    <router-link to="/patients">Patients</router-link>
    <router-link to="/feedback">Feedbacks</router-link>
    <router-link to="/subscribers">Subscribers</router-link>
    <router-link to="/banners">Banners</router-link>
    <router-link to="/packages">Packages</router-link>
    <router-link to="/faq">FAQ</router-link>

    <div class="user">
      <div class="avatar">
        <Avatar
          :size="40"
          variant="pixel"
          name="root@nxgenlabs.com.pk"
          :square="false"
          :colors="colors"
        />
      </div>
      <div class="info">
        <span class="email">{{ email }}</span>
        <span class="level">Level {{ level }}</span>
      </div>
    </div>
    <button
      class="btn btn-primary w-10 font-weight-bold logout"
      @click="logout"
    >
      Logout
    </button>
  </div>
</template>

<script>
import Avatar from "vue-boring-avatars";

export default {
  props: [],
  components: {
    Avatar,
  },
  data() {
    return {
      colors: ["green", "white", "red", "orange", "red"],
      email: "",
      level: "",
    };
  },
  methods: {
    logout() {
      localStorage.removeItem("email");
      localStorage.removeItem("token");
      localStorage.removeItem("id");
      localStorage.removeItem("name");
      this.$router.push({ name: "login" });
    },
  },
  mounted() {
    console.log("mounted");
    this.email = localStorage.getItem("email");
    this.level = localStorage.getItem("access_level");
    console.log(this.email);
  },
};
</script>

<style lang="scss">
#nav {
  // position: fixed;
  // top: 0;
  // left: 0;
  // z-index: 1;
  // width: 100%;
  padding: 15px 20px 15px 15px;
  //   border-bottom: 0.5px solid white;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
  transition: all 0.25s;
  border-bottom: 1px solid orange;
  background: white;

  img {
    height: 25px;
    margin-right: 25px;
    border-right: 1px solid white;
    padding-right: 25px;
  }

  a {
    font-weight: bold;
    color: black;
    margin: 0px 4px;
    font-size: 14px;
    min-width: 100px;
    text-align: center;
    transition: all 0.25s;

    &.router-link-exact-active {
      color: orange;
      font-weight: bolder;
      font-size: 18px;
      padding: 2px 8px;
      transition: all 0.25s;
    }
  }

  .user {
    height: 100%;
    margin-left: auto;
    margin-right: 2rem;
    display: flex;
    align-items: center;
    border-right: 1px solid lightgray;
    padding-right: 1.6rem;

    .avatar {
      height: 2.5rem;
      width: 2.5rem;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 0.5rem;
      box-shadow: 0rem 0rem 0.4rem 0rem lightgray;
    }

    .info {
      display: flex;
      flex-direction: column;

      .email {
        font-size: 0.8rem;
        font-weight: bold;
      }

      .level {
        font-size: 0.8rem;
      }
    }
  }

  .logout {
  }
}
</style>
